import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { AttendanceStatus, IAttendance } from '@internal-models/attendance.model';
import { IWalkInAttendance } from '@internal-models/walk-in-attendance.model';

@Injectable({
	providedIn: 'root',
})
export class AttendanceProvider extends Provider<IAttendance> {
	protected readonly url: string = '/attendances';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getAttendanceForWalkIn(eventId: string, calendarEventId: string): Promise<IWalkInAttendance> {
		return this.process(this.api.get(`${this.url}/${eventId}/${calendarEventId}`)) as Promise<IWalkInAttendance>;
	}

	public getNonAnonymousAttendancesOfEventDay(eventId: string, calendarEventId: string): Promise<any> {
		return this.process(
			this.api.download(`${this.url}/export/${eventId}/${calendarEventId}`, `Aanwezigheden_Export.xlsx`)
		);
	}

	public updateStatus(attendanceId: string, attendance: { status: AttendanceStatus }): Promise<void> {
		return this.process(this.api.put(`${this.url}/${attendanceId}`, attendance)) as any as Promise<void>;
	}

	public saveAttendanceForWalkIn(
		eventId: string,
		calendarEventId: string,
		attendance: IWalkInAttendance
	): Promise<void> {
		return this.process(
			this.api.put(`${this.url}/${eventId}/${calendarEventId}`, attendance)
		) as any as Promise<void>;
	}
}
